/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

angular.module('bulbApp.organizationModule', ['ui.router', 'bulbApp.authModule', 'bulbApp.configModule',
  'bulbApp.filtersModule', 'bulbApp.utilsModule'])
.constant('ORGANIZATION', {
  MAIN_BULB_ORGANIZATION_ID: 999999
})
.run(['$rootScope', 'ORGANIZATION', function($rootScope, ORGANIZATION) {
  $rootScope.ORGANIZATION = ORGANIZATION;
}])
.config(['$stateProvider', 'AUTH', function($stateProvider, AUTH) {
  $stateProvider
    .state('organizations_admin', {
      parent: 'bulbView',
      url: '^/b/organizations',
      resolve: {
        allOrganizations: ['Restangular', 'BulbBusyService', function(Restangular, BulbBusyService) {
          return BulbBusyService.showBusyDuring(Restangular.all('organizations').getList());
        }],
        $title: ['$translate', $translate => $translate('organization_title')],
      },
      views: {
        'bulbView': {
          templateUrl: 'ajs/organization/organizations.html',
          controller: 'OrganizationsController as organizationsCtrl'
        }
      },
      bulbAuth: {
        authorizedRoles: [AUTH.ROLES.ADMIN]
      }
    })
    .state('organizations_bulb_admin', {
      parent: 'bulbView',
      url: '^/b/organizations/bulb',
      resolve: {
        allMetrics: ['Restangular', 'BulbBusyService', (Restangular, BulbBusyService) => BulbBusyService.showBusyDuring(Restangular.one('admin/metrics').get())],
        topOrganization: ['allMetrics', 'ORGANIZATION', function(allMetrics, ORGANIZATION) {
          return {
            id: ORGANIZATION.MAIN_BULB_ORGANIZATION_ID,
            metrics: allMetrics
          };
        }],
        $title: ['$translate', $translate => $translate('organization_title')],
      },
      views: {
        'bulbView': {
          templateUrl: 'ajs/organization/organization-bulb-admin.html',
          controller: 'OrganizationBulbAdminController as organizationBulbAdminCtrl'
        }
      },
      bulbAuth: {
        authorizedRoles: [AUTH.ROLES.ADMIN]
      }
    })
    .state('organization', {
      parent: 'bulbView',
      url: '^/b/organization/~i{id}',
      resolve: {
        topOrganization: ['$stateParams', 'Restangular', 'BulbBusyService', function($stateParams, Restangular, BulbBusyService) {
          localStorage.setItem('organizationId', $stateParams.id);
          return BulbBusyService.showBusyDuring(
            Restangular.one('groups', $stateParams.id).customGET(null, { metrics:true })
          );
        }],
        featureSetInfo: () => import('bulbFeatureSets'),
        $title: ['$translate', $translate => $translate('organization_title')],
      },
      views: {
        'bulbView': {
          templateUrl: 'ajs/organization/organization.html',
          controller: 'OrganizationController as organizationCtrl'
        }
      },
      bulbAuth: {
        authorizedRoles: [AUTH.ROLES.ADMIN, AUTH.ROLES.ORGANIZATION_ADMIN]
      }
    });
}]);
